import { render } from "./brands.vue?vue&type=template&id=8b1421be&scoped=true&ts=true"
import script from "./brands.vue?vue&type=script&lang=ts"
export * from "./brands.vue?vue&type=script&lang=ts"

import "./brands.vue?vue&type=style&index=0&id=8b1421be&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b1421be"]])

export default __exports__